import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';


enum DisbursementServiceEnum {
    send = '',
    sendConvenio = '/convenio',
    recededTradePerSla = '/receded/trade/sla'
}

export default class DisbursementService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, '/disbursement');
    }


    public sendDisbursement = async (tradeId: number, datePayment: string, forceDisbursement: boolean) => {
        await this.POST(DisbursementServiceEnum.send + `/?tradeId=${tradeId}&datePayment=${datePayment}&forceDisbursement=${forceDisbursement}`, null);
    };

    public sendDisbursementConvenio = async (tradeId: number, datePayment: string) => {
        await this.POST(DisbursementServiceEnum.sendConvenio + `/?tradeConvenioId=${tradeId}&datePayment=${datePayment}`, null);
    };

    public disbursementRecededTradePerSla = async (tradeId: number, reason: string) => {
        await this.POST(DisbursementServiceEnum.recededTradePerSla + `/?tradeId=${tradeId}&reason=${reason}`, null);
    };

}



// WEBPACK FOOTER //
// ./src/services/api/Disbursement.service.ts